(function () {
  var selectors = [
    '.jdgm-review-widget:not([data-from-snippet="true"]) .jm-media-grid__image',
    '.jdgm-review-widget:not([data-from-snippet="true"]) .jdgm-rev__pic-img',
    '.jdgm-review-widget:not([data-from-snippet="true"]) .jdgm-gallery__thumbnail'
  ].join(',');

  var timestampSelector = [
    '.jdgm-review-widget:not([data-from-snippet="true"]) .jdgm-rev__timestamp',
    '.jdgm-review-widget:not([data-from-snippet="true"]) .jm-reviewer-info__details .jm-text'
  ].join(',');

  function refreshImage(image) {
    if (!image || image.dataset.mokoJudgemeImageChecked === 'true') return;

    var source = image.currentSrc || image.getAttribute('src') || image.getAttribute('data-src');
    if (!source) return;

    image.dataset.mokoJudgemeImageChecked = 'true';
    image.referrerPolicy = 'no-referrer';
    image.loading = 'eager';

    image.addEventListener('error', function () {
      if (image.dataset.mokoJudgemeImageRetried === 'true') return;
      image.dataset.mokoJudgemeImageRetried = 'true';
      image.referrerPolicy = 'no-referrer';
      image.removeAttribute('srcset');
      image.src = source;
    }, { once: true });

    if (image.complete && image.naturalWidth === 0) {
      image.dataset.mokoJudgemeImageRetried = 'true';
      image.removeAttribute('srcset');
      image.src = source;
    }
  }

  function refreshImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(selectors).forEach(refreshImage);
  }

  var reviewDateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  });

  function formatReviewDateParts(month, day, year) {
    var monthNumber = parseInt(month, 10);
    var dayNumber = parseInt(day, 10);
    var yearNumber = parseInt(year.length === 2 ? '20' + year : year, 10);

    if (Number.isNaN(monthNumber) || Number.isNaN(dayNumber) || Number.isNaN(yearNumber)) return null;
    if (monthNumber < 1 || monthNumber > 12 || dayNumber < 1 || dayNumber > 31) return null;

    var date = new Date(Date.UTC(yearNumber, monthNumber - 1, dayNumber, 12));
    if (date.getUTCFullYear() !== yearNumber || date.getUTCMonth() !== monthNumber - 1 || date.getUTCDate() !== dayNumber) return null;

    return reviewDateFormatter.format(date);
  }

  function formatDateValue(value) {
    if (!value) return value;

    var formattedValue = value.replace(/\b(\d{4})[\/.-](\d{1,2})[\/.-](\d{1,2})\b/, function (match, yearPart, monthPart, dayPart) {
      return formatReviewDateParts(monthPart, dayPart, yearPart) || match;
    });

    return formattedValue.replace(/\b(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{2,4})\b/, function (match, firstPart, secondPart, yearPart) {
      return formatReviewDateParts(firstPart, secondPart, yearPart) || match;
    });
  }

  function formatReviewDate(dateElement) {
    if (!dateElement) return;

    var currentText = dateElement.textContent;
    var formattedText = formatDateValue(currentText);
    var currentTitle = dateElement.getAttribute('title');
    var formattedTitle = formatDateValue(currentTitle);
    var didFormat = false;

    if (formattedText !== currentText) {
      dateElement.textContent = formattedText;
      didFormat = true;
    }

    if (formattedTitle && formattedTitle !== currentTitle) {
      dateElement.setAttribute('title', formattedTitle);
      didFormat = true;
    }

    if (didFormat) {
      dateElement.dataset.mokoJudgemeDateFormatted = 'true';
      dateElement.dataset.mokoJudgemeDateText = dateElement.textContent;
    } else if (dateElement.dataset.mokoJudgemeDateFormatted === 'true' && dateElement.dataset.mokoJudgemeDateText !== currentText) {
      delete dateElement.dataset.mokoJudgemeDateFormatted;
      delete dateElement.dataset.mokoJudgemeDateText;
    }
  }

  function formatReviewDates(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(timestampSelector)) {
      formatReviewDate(scope);
    }
    scope.querySelectorAll(timestampSelector).forEach(formatReviewDate);
  }

  function findReviewHeader() {
    return document.querySelector('.jdgm-review-widget:not([data-from-snippet="true"]) .jdgm-rev-widg__header');
  }

  function findMedalsBlock() {
    return document.querySelector('.jdgm-medals-section:not([data-from-snippet="true"]), .jdgm-medals:not([data-from-snippet="true"]), .shopify-block:has(.jdgm-medal)');
  }

  function enhanceReviewHeader() {
    var header = findReviewHeader();
    if (!header) return;

    if (!header.querySelector('.moko-judgeme-recommend')) {
      var recommend = document.createElement('div');
      recommend.className = 'moko-judgeme-recommend';
      recommend.innerHTML = '<strong>98%</strong><span>would recommend these products</span>';
      header.appendChild(recommend);
    }

    if (!header.querySelector('.moko-judgeme-medals')) {
      var medalsBlock = findMedalsBlock();
      if (medalsBlock && !medalsBlock.closest('.jdgm-rev-widg__header')) {
        var medalsWrap = document.createElement('div');
        medalsWrap.className = 'moko-judgeme-medals';
        medalsWrap.appendChild(medalsBlock);
        header.appendChild(medalsWrap);
      }
    }
  }

  var ratingStarSvg = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0.44043L11.7816 6.07563L18 6.97923L13.5 11.3652L14.562 17.5596L9 14.6352L3.438 17.5596L4.5 11.3652L0 6.97923L6.2184 6.07563L9 0.44043Z" fill="currentColor"/></svg>';

  function normalizeReviewNumber(value) {
    if (!value) return 0;

    var normalized = String(value).replace(/\s+/g, '').replace(',', '.');
    var number = parseFloat(normalized);
    return Number.isNaN(number) ? 0 : number;
  }

  function parseReviewCount(value) {
    if (!value) return 0;

    var normalized = String(value).replace(/\s+/g, '');
    var number = parseInt(normalized.replace(/[,.](?=\d{3}\b)/g, ''), 10);
    return Number.isNaN(number) ? 0 : number;
  }

  function parseJudgeMeSummaryFromText(text) {
    if (!text) return null;

    var cleanText = text.replace(/\s+/g, ' ').trim();
    var compactText = cleanText.replace(/\s+/g, '');
    var countMatch = cleanText.match(/([\d\s,.]+)\s+reviews?\b/i) || compactText.match(/\(([\d,.]+)reviews?\)/i);
    var ratingMatch = cleanText.match(/\b([0-5](?:[.,]\d+)?)\s*(?:\/\s*5|out of 5|\(?\s*[\d\s,.]+\s+reviews?\b)/i) || compactText.match(/^([0-5](?:[.,]\d+)?)\(([\d,.]+)reviews?\)/i);
    var rating = ratingMatch ? normalizeReviewNumber(ratingMatch[1]) : 0;
    var count = countMatch ? parseReviewCount(countMatch[1]) : 0;

    if (!count && ratingMatch && ratingMatch[2]) {
      count = parseReviewCount(ratingMatch[2]);
    }

    if (rating > 0 && rating <= 5 && count > 0) {
      return {
        rating: Math.round(rating * 10) / 10,
        count: count
      };
    }

    return null;
  }

  function readJudgeMeSummary() {
    var widget = document.querySelector('#judgeme_product_reviews.jdgm-review-widget:not([data-from-snippet="true"]), #judgeme_product_reviews .jdgm-review-widget:not([data-from-snippet="true"])');
    if (!widget) return null;

    var summarySelectors = [
      '.jdgm-rev-widg__summary',
      '.jdgm-rev-widg__summary-inner',
      '.jm-average-rating-display__content',
      '.jdgm-widget-actions-wrapper'
    ];

    for (var i = 0; i < summarySelectors.length; i += 1) {
      var summary = widget.querySelector(summarySelectors[i]);
      var parsedSummary = parseJudgeMeSummaryFromText(summary && summary.textContent);
      if (parsedSummary) return parsedSummary;
    }

    return parseJudgeMeSummaryFromText(widget.textContent);
  }

  function createRatingStars(summary) {
    var numberGap = Math.max(Math.ceil(5 - summary.rating - 1), 0);
    var stars = document.createElement('div');
    stars.className = 'rating-star flex por moko-judgeme-rating-bridge';
    stars.setAttribute('aria-hidden', 'true');
    stars.style.setProperty('--rating', summary.rating);
    stars.style.setProperty('--rating-max', '5');
    stars.style.setProperty('--number-gap', numberGap);
    stars.innerHTML = ratingStarSvg + ratingStarSvg + ratingStarSvg + ratingStarSvg + ratingStarSvg;
    return stars;
  }

  function createRatingInfo(summary) {
    var ratingText = document.createElement('p');
    ratingText.className = 'rating-text rating__info__text margin0 font-body-bold moko-judgeme-rating-bridge';

    var ratingValue = document.createElement('span');
    ratingValue.setAttribute('aria-hidden', 'true');
    ratingValue.textContent = summary.rating.toFixed(1).replace(/\.0$/, '');
    ratingText.appendChild(ratingValue);

    return ratingText;
  }

  function syncBestSellerBadge(rating, info, summary) {
    if (!rating || !summary) return;

    if (info) {
      var nestedBadge = info.querySelector('.rating-best-seller-badge');
      if (nestedBadge) nestedBadge.remove();
    }

    var badge = Array.prototype.find.call(rating.children, function (child) {
      return child.classList && child.classList.contains('rating-best-seller-badge');
    });
    var isBestSeller = summary.count >= 20 && summary.rating >= 4;

    if (!isBestSeller) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'rating-best-seller-badge font-body-bold moko-judgeme-rating-bridge';
      badge.setAttribute('aria-label', 'Choice');
      badge.innerHTML = '<span class="rating-best-seller-badge__icon" aria-hidden="true"><svg viewBox="0 0 20 20" focusable="false"><path d="M10 2.35l1.42 1.52 2.08-.14.5 2.02 1.8 1.04-.9 1.88.9 1.88-1.8 1.04-.5 2.02-2.08-.14L10 15l-1.42-1.53-2.08.14-.5-2.02-1.8-1.04.9-1.88-.9-1.88L6 5.75l.5-2.02 2.08.14L10 2.35Z" fill="currentColor"/><path d="M7.25 9.15l1.65 1.65 3.85-3.9" fill="none" stroke="rgb(var(--color-background))" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>Choice</span>';
      rating.appendChild(badge);
    }
  }

  function getMainProductRatingWrapper(mainProduct) {
    var wrapper = mainProduct.querySelector('.rating-wrapper--standard:not(.produit-special__rating-wrapper):not(.produit-special__home-rating-wrapper)');
    if (wrapper) return wrapper;

    var title = mainProduct.querySelector('.product__title');
    if (!title) return null;

    wrapper = document.createElement('a');
    wrapper.className = 'rating-wrapper w100 flex align-center rating-wrapper--standard link link--text moko-judgeme-rating-bridge-wrapper';
    wrapper.href = '#judgeme_product_reviews';
    wrapper.innerHTML = '<div class="rating rating--in-main flex align-center"><div class="rating__info rating__info--standard flex caption lh1"></div></div>';
    title.insertAdjacentElement('afterend', wrapper);
    return wrapper;
  }

  function syncMainProductRatingFromJudgeMe() {
    var summary = readJudgeMeSummary();
    if (!summary) return;

    document.querySelectorAll('[id^="MainProduct-"]').forEach(function (mainProduct) {
      if (mainProduct.closest('.produit-special')) return;

      var wrapper = getMainProductRatingWrapper(mainProduct);
      if (!wrapper) return;

      var rating = wrapper.querySelector('.rating--in-main');
      if (!rating || rating.querySelector('.rating-star')) return;

      var info = rating.querySelector('.rating__info--standard');
      if (!info) {
        info = document.createElement('div');
        info.className = 'rating__info rating__info--standard flex caption lh1';
        rating.appendChild(info);
      }

      wrapper.dataset.mokoJudgemeRatingBridge = 'true';
      if (wrapper.tagName.toLowerCase() === 'a' && !wrapper.getAttribute('href')) {
        wrapper.setAttribute('href', '#judgeme_product_reviews');
      }

      rating.setAttribute('role', 'img');
      rating.setAttribute('aria-label', summary.rating + ' out of 5 stars');
      rating.insertBefore(createRatingStars(summary), rating.firstChild);

      info.classList.remove('rating__info--sold-only');
      if (!info.querySelector('.rating__info__text')) {
        info.insertBefore(createRatingInfo(summary), info.firstChild);
      }

      syncBestSellerBadge(rating, info, summary);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshImages(document);
    formatReviewDates(document);
    enhanceReviewHeader();
    syncMainProductRatingFromJudgeMe();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(selectors)) {
            refreshImage(node);
          }
          refreshImages(node);
          formatReviewDates(node);
        });
      });
      formatReviewDates(document);
      enhanceReviewHeader();
      syncMainProductRatingFromJudgeMe();
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
})();
